<template>
  <div class="search-ui">
    <!-- <div class="search-cat"></div> -->
    <div class="search">
      <form class="clearfix" method="GET" target="_blank" autocomplete="off"
            v-on:submit.prevent="onSubmit"
      >
        <div class="text-box-outer">
          <div class="text-box">
            <div class="icon">
              <a class="cur" href="javascript:;" target="_self">
                <img height="20" width="20" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAABGdBTUEAALGPC/xhBQAAANhQTFRFNG3wNG3wNG3wNG3wNG3wAAAAVobzPXPxdZz1iKn2o734nLj45ez9p8D5YY7z9/n+O3LxNm7wSXzyYY3zf6P2XYrzl7T3aJL0RXnxk7H3OHDwus36QXbxt8v6v9H6lbP3iar2TX/ycZn1Q3jxytn7j673RnrxhKb2xtb7PnTxPHPxOXDwWYfzq8P5R3vxToDymLX3UoPylLL3+Pr+U4Pyd5310N38N2/w1uH8+vz/Qnfxu876+/z/NW7wm7f4/v7/OnHwz937bJX0Nm/w8/b+/f7/////NG3w6rqWpwAAAAZ0Uk5T5OdKSeYA+kEftgAAAMNJREFUGNNt0OUOwkAQBOACxd3d3bXFaansvP8bcVSuNGF/Xb5sMrcjhP+MEA6J8I0YYii+yTdvkSGsZyWXplSm9GBPcGyhRlWg7UPgSU/gxfF+69EcQ+oDF44FqNfpZEz3bbdZTNhoqjg/7GTzhqizecCAaLba7BQDOCtOkGHSaIlvjJaP8XRzvfgeo3coq7hoaM6Jev3I/yl5l2scGz99HF0se3bim5e9vpcOyXhEPck2WtVdverkAMNgwF+yEGT4Zz62JE4+Qtp+1AAAAABJRU5ErkJggg==" />
              </a>
            </div>
            <input name="ie" value="UTF-8" type="hidden" />
            <input class="ipt-text" id="ipt-text" name="q" type="text" placeholder="" v-model="iptValue"
                   v-on:keydown="onKeyDown" v-on:input="onInput" v-on:dblclick="onInput" v-on:blur="onLoseFocus"
            />
            <input name="src" value="pclm" type="hidden" />
            <input name="ls" value="pclm2345w_8" type="hidden" />
          </div>
        </div>
        <div class="btn-box">
          <input class="ipt-btn" name="" type="submit" value="搜一下"
                 v-on:click.prevent="goSearch"
          />
        </div>
      </form>
      <!-- 搜索联想 -->
      <div class="suglist" id="suglist" style="display:block;" v-bind:style="displayObject">
        <ul id="content_list">
          <li v-for="(item, index) in suggestList" v-html="genHtml(item)"
              v-bind:class="{ cur: index == selectIndex }"
              v-on:click.prevent="goSearch(item)" v-bind:key="index"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import search from '../api/search';
import stats from '../api/statistics';

export default {
  name: 'SearchBar',
  data () {
    return {
      iptValue: '',
      // 原始输入文字
      originInput: '',
      selectIndex: -1,
      suggestList: [],
      displayObject: {
        display: 'none'
      }
    }
  },
  mounted () {
    this.setDefaultWord()
  },
  methods: {
    genHtml (text) {
      return text.replace(this.originInput, '<strong>' + this.originInput + '</strong>')
    },
    getSuggest (inputText) {
      this.iptValue = inputText
    },
    goSearch (text) {
      if (text instanceof Event) {
        text = this.iptValue
      }
//      df.ajaxClick('Error_360_search')
      stats.ajax99('Error_baidu_search')
      search.searchBaidu(text)
    },
    onSubmit () {
      return false
    },
    onLoseFocus () {
      var self = this
      setTimeout(function () {
        self.displayObject.display = 'none'
//        console.log('display none')
      }, 200)
    },
    onInput (event) {
      switch (event.keyCode) {
        // 过滤部分键不触发搜索联想事件
        case 13:    // Enter： 触发搜索不触发联想
        case 27:    // Esc
        case 35:    // end
        case 36:    // home
        case 37:    // ←
        case 38:    // ↑
        case 39:    // →
        case 40:    // ↓
          break
        // 部分键会引起值的改变也可能不会，需要判断
        // case 46:     // delete
        // case 45:     // insert
        // 触发搜索框值得改变引起的搜索
        default:
          var iptValue = document.getElementById('ipt-text').value
          this.originInput = iptValue
          this.selectIndex = -1
          this.getSuggest(iptValue)
      }
    },
    onKeyDown (event) {
      var keyCode = event.keyCode
      switch (keyCode) {
        // BackSpace
        case 8:
          break
        // Esc:关闭联想
        case 27:
          this.displayObject.display = 'none'
          break
        // Space 空格键 中文空格忽略 229
        case 32:
          // 关闭top列表
          break
        // Up: 联想向上
        case 33:    // PageUp
        case 38:    // ↑
          this.searchSuggestStep(-1)
          event.preventDefault()
          break
        // Down: 联想向下
        case 34:    // PageDown
        case 40:    // ↓
          this.searchSuggestStep(1)
          event.preventDefault()
          break
        default:
          // console.log("search input keydown :", keyCode);
          break
      }
    },
    searchSuggestStep (step) {
      if (this.suggestList.length === 0 || this.iptValue === '') {
        return false
      }
      if (this.displayObject.display === 'none') {
        step = 0
      }

      this.displayObject.display = 'block'
      var index = this.selectIndex + step
      var total = this.suggestList.length + 1
      index = (index + 1 + total) % total - 1
      this.selectIndex = index
      this.iptValue = index < 0 ? this.originInput : this.suggestList[index] // 确定搜索框的值
    },
    setDefaultWord () {
      if (/defwd=([^=&]+)/.test(window.location.href.slice(window.location.href.indexOf('?') + 1))) {
        this.iptValue = decodeURI(RegExp.$1)
      }
    }
  }
}
</script>
